import { PaymentReceiversCommandVersionsService_paymentReceiverCommandVersionsServiceGetQuery } from '@festina/moneyout-general-types/moneyout/hooks/PaymentReceiversCommandVersionsService_paymentReceiverCommandVersionsServiceGetQuery'

export const useFetchPaymentReceiverCommands =
  PaymentReceiversCommandVersionsService_paymentReceiverCommandVersionsServiceGetQuery.useSuspenseQuery
